/*global angular*/
module.exports = ['sriClient', function (sriClient) {
  'use strict';
  return {
    restrict: 'E',
    template: '<span>{{name}}</span>',
    replace: true,
    transclude: true,
    scope: {
      href: '='
    },
    link: function (scope) {
      if (scope.href) {
        sriClient.get(scope.href)
          .then(function (data) {
            scope.name = data.$$name;
          });
      }
    }
  };
}];



// WEBPACK FOOTER //
// ./web/js/module/visionText/js/organisationName/organisationName.js